export default {
    DEMO: 'DEMO',
    UPDATE_TOKEN: 'UPDATE_TOKEN',
    UPDATE_USERINFO: 'UPDATE_USERINFO',
}